import React, { useState, useCallback, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import { getAuth } from "firebase/auth";
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/react';
import LoadingSpinner from "../LoadingSpinner";
import { ReactComponent as DeleteIcon } from '../../assets/icons/DeleteIcon.svg';
import { ReactComponent as ClipIcon } from '../../assets/icons/ClipIcon.svg';
import { ReactComponent as LinkIcon } from '../../assets/icons/LinkIcon.svg';
import { ReactComponent as PdfIcon } from '../../assets/icons/PdfIcon.svg';
import { ReactComponent as EpubIcon } from '../../assets/icons/EpubIcon.svg';
import { ReactComponent as VideoIcon } from '../../assets/icons/VideoIcon.svg';
import { ReactComponent as AudioIcon } from '../../assets/icons/AudioIcon.svg';
import { ReactComponent as DropArrow } from '../../assets/icons/DropArrow.svg';
const URLModal = ({ show, subiendo, urlForm, handleChange, handleSubmit, onClose, mensaje }) => {
if (!show) return null;
return (
<div className="biblioteca-modal-backdrop">
<div className="biblioteca-modal-content">
<button
onClick={onClose}
className="biblioteca-modal-close-btn"
>
<p className="biblioteca-modal-close-icon">&times;</p>
</button>
<h2 className="biblioteca-modal-title">Subí un archivo a la Biblioteca Digital</h2>
<form onSubmit={handleSubmit} className="biblioteca-modal-form">
<div className="biblioteca-form-group">
<input
type="url"
id="url"
name="url"
value={urlForm.url}
onChange={handleChange}
required
placeholder="Pegá aca la dirección url"
className="biblioteca-form-input"
/>
</div>
<div className="biblioteca-form-group">
<input
type="text"
id="titulo"
name="titulo"
value={urlForm.titulo}
onChange={handleChange}
placeholder="Poné un título"
className="biblioteca-form-input"
/>
</div>
<div className="biblioteca-form-group">
<input
type="text"
id="autor"
name="autor"
value={urlForm.autor}
onChange={handleChange}
placeholder="Nombrá al autor"
className="biblioteca-form-input"
/>
</div>
<div className="biblioteca-form-group" 
style={{display:'flex',flexDirection:'column',border:'1px solid #eeeff2',margin:'0 15px', backgroundColor:'white',borderRadius:'7px'}}>
<textarea
id="descripcion"
name="descripcion"
value={urlForm.descripcion}
onChange={handleChange}
placeholder="Redactá una breve descripción"
rows="5"
className="biblioteca-form-textarea"
maxLength={140}
style={{padding:'5px 15px',margin:'0', border:'none'}}
/>
<div style={{
textAlign: 'right',
fontSize: '12px',
color: '#888',
margin:'5px 7px'
}}>
{urlForm.descripcion.length} / 140
</div>
</div>
<div className="biblioteca-modal-actions">
<button
type="submit"
disabled={subiendo || !urlForm.url}
className="biblioteca-submit-btn"
>
Compartir
</button>
</div>
</form>
</div>
</div>
);
};
const ArchivoModal = ({ show, archivo, archivoForm, handleChange, handleSubmit, onClose, subiendo, mensaje }) => {
if (!show) return null;
return (
<div className="biblioteca-modal-backdrop">
<div className="biblioteca-modal-content">
<button
onClick={onClose}
className="biblioteca-modal-close-btn"
>
<p className="biblioteca-modal-close-icon">&times;</p>
</button>
<h2 className="biblioteca-modal-title">
Subí un archivo a la Biblioteca Digital
</h2>
{archivo && (
<p style={{ fontSize: "14px", color: "#666", width:'87%', overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap", margin:'0 auto 20px', display:'flex', flexDirection:'row', alignItems:'center', gap:'10px' }}>
<ClipIcon style={{height:'15px', margin:'auto 0', overflow:'visible'}}/> <b style={{ overflow: "hidden",
textOverflow: "ellipsis",
whiteSpace: "nowrap",fontSize: '15px', fontFamily:'Effra', fontWeight:'normal', color: '#2c2c2c'}}>{archivo.name}</b>
</p>
)}
<form onSubmit={handleSubmit} className="biblioteca-modal-form">
<div className="biblioteca-form-group">
<input
type="text"
id="titulo"
name="titulo"
value={archivoForm.titulo}
onChange={handleChange}
placeholder="Poné un título"
className="biblioteca-form-input"
required
/>
</div>
<div className="biblioteca-form-group">
<input
type="text"
id="autor"
name="autor"
value={archivoForm.autor}
onChange={handleChange}
placeholder="Nombrá al autor"
className="biblioteca-form-input"
/>
</div>
<div className="biblioteca-form-group" 
style={{display:'flex',flexDirection:'column',border:'1px solid #eeeff2',margin:'0 15px', backgroundColor:'white',borderRadius:'7px'}}>
<textarea
id="descripcion"
name="descripcion"
value={archivoForm.descripcion}
onChange={handleChange}
placeholder="Redactá una breve descripción"
rows="5"
className="biblioteca-form-textarea"
maxLength={140}
style={{padding:'5px 15px',margin:'0', border:'none'}}
/>
<div style={{
textAlign: 'right',
fontSize: '12px',
color: '#888',
margin:'5px 7px'
}}>
{archivoForm.descripcion.length} / 140
</div>
</div>
<div className="biblioteca-modal-actions">
<button
type="submit"
className="biblioteca-submit-btn"
>
Compartir
</button>
</div>
</form>
</div>
</div>
);
};
const RatingStars = ({ archivo, usuarioActualId, onVotar }) => {
const userRating = archivo.ratings?.[usuarioActualId] || 0;
const promedio = archivo.promedio || 0;
const totalVotos = archivo.totalVotos || 0;
const [hoverValue, setHoverValue] = useState(0);
const [hoverPercent, setHoverPercent] = useState(0);
const yaVoto = userRating > 0;
const fillColor = yaVoto ? "#999" : "#e65c5c"; 
const handleMouseMove = (e, star) => {
if (yaVoto) return;
const { left, width } = e.currentTarget.getBoundingClientRect();
const percent = ((e.clientX - left) / width) * 100;
const roundedPercent = percent < 25 ? 0 : percent < 75 ? 50 : 100;
setHoverValue(star);
setHoverPercent(roundedPercent);
};
const handleMouseLeave = () => {
if (yaVoto) return;
setHoverValue(0);
setHoverPercent(0);
};
return (
<div style={{ display: "flex", alignItems: "start", gap: "0px",height:'fit-content', flexDirection:'column',padding:'0 0 5px',width:'92%',margin:'0 0 0 auto', borderBottom: '1px solid #e0e3e7' }}>
{!yaVoto && (
<span style={{ fontSize: "12px", color: "#666",margin:'0',padding:'0' }}>
¿Qué tan util lo encontraste?
</span>
)}
<div style={{ display: "flex", alignItems: "center",flexDirection:'row',margin:'0',gap:'3px',height:'25px'  }}>
{[1, 2, 3, 4, 5].map((star) => {
let fillPercent = 0;
if (yaVoto) {
if (promedio >= star) fillPercent = 100;
else if (promedio >= star - 1) fillPercent = (promedio - (star - 1)) * 100;
} else if (hoverValue > 0) {
if (star < hoverValue) fillPercent = 100;
else if (star === hoverValue) fillPercent = hoverPercent;
}
return (
<span
key={star}
style={{
position: "relative",
display: "inline-block",
fontSize: "16px",
margin: 0,
padding: 0,
cursor: yaVoto ? "default" : "pointer",
color: "transparent",
WebkitTextStroke: `1px ${fillColor}`,
}}
onMouseMove={(e) => handleMouseMove(e, star)}
onMouseLeave={handleMouseLeave}
onClick={() => {
if (!yaVoto) {
let finalRating = star - 1 + hoverPercent / 100;
finalRating = Math.round(finalRating * 2) / 2;
onVotar(archivo.id, finalRating);
}
}}
>
★
<span
style={{
color: fillColor,
position: "absolute",
top: 0,
left: 0,
width: `${fillPercent}%`,
overflow: "hidden",
whiteSpace: "nowrap",
WebkitTextStroke: "0",
}}
>
★
</span>
</span>
);
})}
</div>
</div>
);
};
const Biblioteca = () => {
const [subiendo, setSubiendo] = useState(false);
const [mensaje, setMensaje] = useState("");
const [listaArchivos, setListaArchivos] = useState([]);
const [archivosRecientes, setArchivosRecientes] = useState([]);
const [cargandoArchivos, setCargandoArchivos] = useState(true);
const [filtroActivo, setFiltroActivo] = useState("todos");
const [showURLModal, setShowURLModal] = useState(false);
const [urlForm, setUrlForm] = useState({
url: "",
titulo: "",
autor: "",
descripcion: "",
});
const [showArchivoModal, setShowArchivoModal] = useState(false);
const [archivoSeleccionado, setArchivoSeleccionado] = useState(null);
const [archivoForm, setArchivoForm] = useState({
titulo: "",
autor: "",
descripcion: "",
});
const [ordenamiento, setOrdenamiento] = useState("reciente");
const handleURLModalSubmit = async (e) => {
e.preventDefault();
if (!urlForm.url) {
setMensaje("La URL no puede estar vacía.");
return;
}
setSubiendo(true);
setMensaje("Subiendo URL...");
try {
const auth = getAuth();
const user = auth.currentUser;
const token = await user.getIdToken();
const response = await fetch("https://backend-288175208699.europe-west1.run.app/subir-url", {
method: "POST",
headers: {
Authorization: `Bearer ${token}`,
"Content-Type": "application/json",
},
body: JSON.stringify(urlForm),
});
const result = await response.json();
if (response.ok) {
setMensaje("URL subida correctamente");
cargarArchivosDeBiblioteca();
setShowURLModal(false);
setUrlForm({ url: "", titulo: "", autor: "", descripcion: "" });
} else {
setMensaje(`Error: ${result.error}`);
}
} catch (error) {
setMensaje(`Error: ${error.message}`);
} finally {
setSubiendo(false);
}
};
const handleURLModalChange = (e) => {
const { name, value } = e.target;
setUrlForm((prevForm) => ({ ...prevForm, [name]: value }));
};
const handleAgregarURL = () => {
setShowURLModal(true);
};
const cargarArchivosDeBiblioteca = useCallback(async () => {
setCargandoArchivos(true);
try {
const auth = getAuth();
const user = auth.currentUser;
if (!user) return;
const token = await user.getIdToken();
const response = await fetch("https://backend-288175208699.europe-west1.run.app/listar-archivos", {
headers: { Authorization: `Bearer ${token}` },
});
if (response.ok) {
const data = await response.json();
const archivosOrdenados = data.sort(
(a, b) => new Date(b.fechaSubida) - new Date(a.fechaSubida)
);
setListaArchivos(archivosOrdenados);
setArchivosRecientes(archivosOrdenados.slice(0, 4));
} else {
setMensaje("No se pudo cargar la lista de archivos.");
}
} catch (error) {
setMensaje(`Error al cargar la biblioteca: ${error.message}`);
} finally {
setCargandoArchivos(false);
}
}, []);
useEffect(() => {
cargarArchivosDeBiblioteca();
}, [cargarArchivosDeBiblioteca]);
const [usuarioActual, setUsuarioActual] = useState(null);
useEffect(() => {
const auth = getAuth();
const unsub = auth.onAuthStateChanged((user) => {
setUsuarioActual(user);
if (user) {
cargarArchivosDeBiblioteca();
}
});
return () => unsub();
}, [cargarArchivosDeBiblioteca]);
const handleEliminarArchivo = async (archivoId) => {
if (window.confirm("¿Estás seguro de que quieres eliminar este archivo? Esta acción no se puede deshacer.")) {
try {
setMensaje("Eliminando archivo...");
const auth = getAuth();
const user = auth.currentUser;
const token = await user.getIdToken();
const response = await fetch("https://backend-288175208699.europe-west1.run.app/eliminar-archivo", {
method: "DELETE",
headers: {
Authorization: `Bearer ${token}`,
"Content-Type": "application/json",
},
body: JSON.stringify({ id: archivoId }),
});
if (response.ok) {
setMensaje("Archivo eliminado correctamente.");
cargarArchivosDeBiblioteca();
} else {
const result = await response.json();
setMensaje(`Error al eliminar: ${result.error}`);
}
} catch (error) {
setMensaje(`Error de red al eliminar el archivo: ${error.message}`);
}
}
};
const onDrop = useCallback((acceptedFiles) => {
if (acceptedFiles.length > 0) {
setArchivoSeleccionado(acceptedFiles[0]);
setShowArchivoModal(true);
}
}, []);
const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
onDrop,
noClick: true,
noKeyboard: true,
});
const handleButtonClick = () => open();
const handleArchivoModalSubmit = async (e) => {
e.preventDefault();
if (!archivoSeleccionado) {
setMensaje("No hay archivo seleccionado.");
return;
}
setSubiendo(true);
setMensaje("Subiendo archivo...");
try {
const auth = getAuth();
const user = auth.currentUser;
if (!user) {
setMensaje("Usuario no logueado.");
setSubiendo(false);
return;
}
const token = await user.getIdToken();
const formData = new FormData();
formData.append("archivo", archivoSeleccionado);
formData.append("titulo", archivoForm.titulo);
formData.append("autor", archivoForm.autor);
formData.append("descripcion", archivoForm.descripcion);
const response = await fetch("https://backend-288175208699.europe-west1.run.app/subir-archivo", {
method: "POST",
headers: { Authorization: `Bearer ${token}` },
body: formData,
});
const result = await response.json();
if (response.ok) {
setMensaje("Archivo subido correctamente.");
cargarArchivosDeBiblioteca();
setShowArchivoModal(false);
setArchivoSeleccionado(null);
setArchivoForm({ titulo: "", autor: "", descripcion: "" });
} else {
setMensaje(`Error: ${result.error}`);
}
} catch (error) {
setMensaje(`Error al subir archivo: ${error.message}`);
}
setSubiendo(false);
};
const ArchivoCard = ({ archivo, isRecentCard, usuarioActualId, handleEliminar }) => {
const fecha = new Date(archivo.fechaSubida).toLocaleDateString("es-AR", {
year: "numeric",
month: "short",
day: "numeric",
hour: "2-digit",
minute: "2-digit",
hour12: false,
});
const maxLines = isRecentCard ? "1" : "2";

const getIconForFile = (item) => {
if (item.tipo === "url") {
if (item.categoria === "video") {
return (
<VideoIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
}
if (item.categoria === "audio") {
return (
<AudioIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
}
return (
<VideoIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
}
if (item.contentType) {
if (
item.contentType.includes("pdf") ||
item.contentType.includes("wordprocessingml") ||
item.contentType.includes("msword")
) {
return (
<PdfIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
}
if (item.contentType.includes("epub")) {
return (
<EpubIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
}
}
return (
<PdfIcon
style={{ height: "16px", overflow: "visible", marginTop: "3px" }}
/>
);
};
const esElAutor = archivo.subidoPor === usuarioActualId;
return (
<div
className={`document-card ${
isRecentCard ? "biblio-recent-card" : "all-card"
} ${archivo.tipo === "url" ? "url-card" : ""}`}
>
<a 
href={archivo.url}
target="_blank"
style={{ textDecoration: "none", padding: "0", display:'flex',flex:'row', gap:'10px' }}
rel="noopener noreferrer">
{getIconForFile(archivo)}
<div className="card-content" style={{ gap: "0", border:'none', gap:'0' }}>
  <div style={{display:'flex',justifyContent:'space-between'}}>
    <span
      style={{
        overflow: "hidden",
        display: "-webkit-box", 
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: maxLines,
        maxWidth: "220px",
        textAlign: "left",
        margin: 0,
      }}
      className="biblio-doc-id"
    >
      {archivo.nombre}
    </span>
    {esElAutor && (
    <div className="sidebar-icon-container" style={{marginRight:'10px'}}>
      <DeleteIcon onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleEliminar(archivo.id);
      }} className="delete-button"/>
    </div>)}
  </div>
  {!isRecentCard && (
    <>
      <span className="card-autor">{archivo.autor}</span>
      <p className="card-description">{archivo.descripcion}</p>
    </>
  )}
  <div className="card-creator-container">
    <p className="card-creator">{archivo.subidoPorNombre}</p>
    <p className="card-date">{fecha}</p>
  </div>
</div>
</a>
{!isRecentCard && (
<RatingStars
archivo={archivo}
usuarioActualId={usuarioActualId}
onVotar={async (archivoId, rating) => {
const auth = getAuth();
const user = auth.currentUser;
const token = await user.getIdToken();
const response = await fetch("https://backend-288175208699.europe-west1.run.app/votar-archivo", {
method: "POST",
headers: {
Authorization: `Bearer ${token}`,
"Content-Type": "application/json",
},
body: JSON.stringify({ id: archivoId, rating }),
});
if (response.ok) {
const data = await response.json();
setListaArchivos((prev) =>
prev.map((archivo) =>
archivo.id === archivoId
? {
...archivo,
promedio: data.promedio,
totalVotos: data.totalVotos,
ratings: {
...(archivo.ratings || {}),
[user.uid]: rating,
},
}
: archivo
)
);
}
}}
/>)}
</div>
);
};
const getArchivosMostrados = () => {
let archivosFiltrados = listaArchivos;
if (filtroActivo !== "todos") {
archivosFiltrados = listaArchivos.filter((archivo) => {
if (archivo.tipo === "url") {
return archivo.categoria === filtroActivo;
}
if (archivo.tipo === "archivo") {
return (
archivo.contentType && archivo.contentType.includes(filtroActivo)
);
}
return false;
});
}
let archivosOrdenados = [...archivosFiltrados];
switch (ordenamiento) {
case "alfabetico":
archivosOrdenados.sort((a, b) => a.nombre.localeCompare(b.nombre));
break;
case "reciente":
archivosOrdenados.sort(
(a, b) => new Date(b.fechaSubida) - new Date(a.fechaSubida)
);
break;
case "antiguo":
archivosOrdenados.sort(
(a, b) => new Date(a.fechaSubida) - new Date(b.fechaSubida)
);
break;
default:
break;
}
return archivosOrdenados;
};
const archivosMostrados = getArchivosMostrados();
return (
<div
{...getRootProps()}
className="Trazabilidad"
style={{
border: isDragActive ? "2px solid #e65c5c" : "2px solid transparent",
}}
>
    {cargandoArchivos ? (
        <LoadingSpinner />
    ) : (
    <>
{isDragActive && (
<div
style={{
position: "absolute",
top: 0,
left: 0,
right: 0,
bottom: 0,
display: "flex",
justifyContent: "flex-end",
alignItems: "center",
borderRadius: "25px",
display: "flex",
flexDirection: "column",
gap: "10px",
zIndex: 10,
}}
>
<DropArrow
style={{ height: "25px", overflow: "visible", marginTop: "3px" }}
/>
<div
style={{
marginBottom: "30px",
backgroundColor: "#e65c5c",
padding: "20px 0",
borderRadius: "100px",
width: "300px",
}}
>
<p
style={{
fontSize: "15px",
lineHeight: "20px",
fontFamily: "Effra",
fontWeight: "normal",
color: "white",
maxWidth: "80%",
textAlign: "center",
margin: "auto",
cursor: "default",
}}
>
Soltá el archivo para agregarlo al Repositorio
</p>
</div>
</div>
)}
<input {...getInputProps()} />
<header className="trazabilidad-header">
<div className="header-content">
<h1>Biblioteca digital</h1>
</div>
</header>
<div className="trazabilidad-content">
<div className="section">
<h2>Recientes</h2>
{archivosRecientes.length > 0 ? (
<div className="recent-grid">
{archivosRecientes.map((archivo, index) => (
<ArchivoCard key={index} archivo={archivo} isRecentCard={true} />
))}
</div>
) : (
<p></p>
)}
</div>
<div className="todos-archivos-section">
<h2
style={{
fontSize: "17px",
fontFamily: "Effra",
fontWeight: "normal",
color: "#555",
cursor: "default",
}}
>
Archivos
</h2>
<div
style={{
display: "flex",
flexDirection: "row",
gap: "10px",
alignContent: "center",
alignItems: "center",
height: "fit-content",
}}
>
<button onClick={handleButtonClick} className="biblioteca-boton">
<ClipIcon
style={{ height: "12px", margin: "auto", overflow: "visible" }}
/>
Adjuntar un archivo
</button>
<button onClick={handleAgregarURL} className="biblioteca-boton">
<LinkIcon
style={{ width: "13px", margin: "auto", overflow: "visible" }}
/>
Pegar una URL
</button>
<div className="custom-listbox-container">
<Listbox value={filtroActivo} onChange={setFiltroActivo}>
{({ open }) => (
<>
<ListboxButton
className={`custom-listbox-button ${open ? "open" : ""}`}
style={{ minWidth: "150px" }}
>
{filtroActivo === "todos"
? "Filtrar por"
: filtroActivo === "pdf"
? "PDF"
: filtroActivo === "audio"
? "Podcast"
: filtroActivo.charAt(0).toUpperCase() + filtroActivo.slice(1)}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{[
{ value: "todos", label: "Todos" },
{ value: "pdf", label: "PDF" },
{ value: "epub", label: "Epub" },
{ value: "video", label: "Video" },
{ value: "audio", label: "Podcast" },
].map((option) => (
<ListboxOption
key={option.value}
value={option.value}
className="custom-listbox-option"
>
{option.label}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
{}
</div>
<div className="biblioteca-listbox-container"  style={{marginTop:'20px',}}>
<Listbox value={ordenamiento} onChange={setOrdenamiento}>
{({ open }) => (
<>
<ListboxButton
className={`biblioteca-listbox-button ${open ? "open" : ""}`}
style={{ minWidth: "150px" }}
>
{ordenamiento === "reciente"
? "Más recientes"
: ordenamiento === "antiguo"
? "Más antiguos"
: "Alfabéticamente"}
<span className="biblioteca-arrow-container">
<span className="biblioteca-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="biblioteca-listbox-options">
<ListboxOption
value="reciente"
className="biblioteca-listbox-option"
>
Más recientes
</ListboxOption>
<ListboxOption
value="antiguo"
className="biblioteca-listbox-option"
>
Más antiguos
</ListboxOption>
<ListboxOption
value="alfabetico"
className="biblioteca-listbox-option"
>
Alfabéticamente
</ListboxOption>
</ListboxOptions>
</>
)}
</Listbox>
</div>
{archivosMostrados.length > 0 ? (
<div className="todos-archivos-grid">
{archivosMostrados.map((archivo) => (
<ArchivoCard 
key={archivo.id} 
archivo={archivo} 
isRecentCard={false} 
usuarioActualId={usuarioActual ? usuarioActual.uid : null} 
handleEliminar={handleEliminarArchivo} 
/>
))}
</div>
) : (
<p>No hay archivos que coincidan con este filtro.</p>
)}
</div>
</div>
<URLModal
show={showURLModal}
subiendo={subiendo}
urlForm={urlForm}
handleChange={handleURLModalChange}
handleSubmit={handleURLModalSubmit}
onClose={() => {
setShowURLModal(false);
setUrlForm({ url: "", titulo: "", autor: "", descripcion: "" });
}}
mensaje={mensaje}
/>
<ArchivoModal
show={showArchivoModal}
archivo={archivoSeleccionado}
archivoForm={archivoForm}
handleChange={(e) =>
setArchivoForm({ ...archivoForm, [e.target.name]: e.target.value })
}
handleSubmit={handleArchivoModalSubmit}
onClose={() => {
setShowArchivoModal(false);
setArchivoSeleccionado(null);
setArchivoForm({ titulo: "", autor: "", descripcion: "" });
}}
subiendo={subiendo}
mensaje={mensaje}
/></>)}
</div>
);
};
export default Biblioteca;
